import React from "react";
import CardsBlock from "./cardsBlock";
import { cardsData5, caseBlockItem } from "../data";
import CaseBlock from "./caseBlock";

export default function MobileMain() {
  return (
    <>
      <div className="container">
        <CardsBlock cards={cardsData5} />
        {/* <div className="cardTopContent">
                <CardBox title={webdev[4].title} text={webdev[4].text} src={webdev[4].src} listTitle={webdev[4].listTitle} list={webdev[4].list} btnText={webdev[4].btnText}/>
                <p className="text-center">Приложение Opt Market доступно для использования только клиентам компании IT Partner. Размер лицензионного вознаграждения за передаваемые права на Мобильное приложение Opt Market рассчитывается индивидуально. </p>
                <p className="text-center">Чтобы стать клиентом компании IT Partner необходимо обратиться по электронному адресу <a href="mailto:" className="btn btnMailCase">info@i-t-p.pro</a></p>
            </div>
            <div className="accordionBlock">
                <div className="accordionColumn w-100">
                    <Accordion title="Скачать руководство пользователя"/>
                    <Accordion title="Скачать описание процессов, обеспечивающих поддержание жизненного цикла"/>
                    <Accordion title="Скачать функциональные характеристики"/>
                </div>
            </div> */}
      </div>
      <div className="casesMainBlock">
        {caseBlockItem.slice(0, 1).map((caseBlockItem) => (
          <CaseBlock
            caseBlockItem={caseBlockItem}
            tags={caseBlockItem.tag}
            links={caseBlockItem.links}
          />
        ))}
      </div>
    </>
  );
}
